export class CartridgeMessage {
  diameterMinimum: number
  name: string
  
  constructor(diameterMinimum: number, name: string) {
    this.diameterMinimum = diameterMinimum
    this.name = name
  }
}
  